import {
  useGroupLabel
} from "./CTVLGQZG.js";
import {
  createComponent,
  createElement,
  createHook
} from "./NQJBHION.js";
import {
  __objRest
} from "./PNRLI7OV.js";

// src/composite/composite-group-label.ts
var useCompositeGroupLabel = createHook(
  (_a) => {
    var _b = _a, { store } = _b, props = __objRest(_b, ["store"]);
    props = useGroupLabel(props);
    return props;
  }
);
var CompositeGroupLabel = createComponent(
  (props) => {
    const htmlProps = useCompositeGroupLabel(props);
    return createElement("div", htmlProps);
  }
);
if (process.env.NODE_ENV !== "production") {
  CompositeGroupLabel.displayName = "CompositeGroupLabel";
}

export {
  useCompositeGroupLabel,
  CompositeGroupLabel
};
